import StateTotalDonutChart from './StateTotalDonutChart';

export default StateTotalDonutChart;
